export default __webpack_public_path__ + "static/media/Belt of Deadly Guile.361af76c.jpg";